import React, { useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import emailjs from "emailjs-com";
import "./Donation.css";

const Donation = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    note: "",
    amount: "",
  });

  const [showQR, setShowQR] = useState(false);
  const [qrValue, setQRValue] = useState("");
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const generateQRCode = () => {
    if (formData.amount && formData.email && formData.phone && formData.name) {
      const upiLink = `upi://pay?pa=9160383791-2@ybl&pn=${formData.name}&am=${formData.amount}&cu=INR`;
      setQRValue(upiLink);
      setShowQR(true);
    }
  };

  const sendDataToGoogleSheet = async () => {
    const scriptURL =
      "https://script.google.com/macros/s/AKfycby_-HL2Sf93ecznA0AEx0bU1Q9ObSqO1ZZp6uxgbXyfw_X4SkFIQqzMALQ1SpYNOvKm/exec";

    const donationData = {
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      note: formData.note || "No additional note",
      amount: formData.amount,
    };

    try {
      await fetch(scriptURL, {
        method: "POST",
        mode: "no-cors",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(donationData),
      });
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const sendEmail = async () => {
    setLoading(true);

    const serviceID = process.env.REACT_APP_EMAILJS_SERVICE_ID ;
    const templateID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
    const userID = process.env.REACT_APP_EMAILJS_API_KEY ;
    const organizationEmail = process.env.REACT_APP_ORG_EMAIL || "srtechcreaters@gmail.com";

    const emailData = {
      to_email: organizationEmail,
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      note: formData.note || "No additional note",
      amount: formData.amount,
    };

    try {
      await emailjs.send(serviceID, templateID, emailData, userID);
      await sendDataToGoogleSheet();

      setFormData({ name: "", email: "", phone: "", note: "", amount: "" });
      setShowQR(false);
    } catch (error) {
      console.error("❌ Error sending email: ", error);
    } finally {
      setLoading(false);
    }
  };

  const handlePaymentSuccess = () => {
    setPaymentSuccess(true);
    sendEmail(); // Send data to email & Google Sheet automatically
  };

  return (
    <div className="donation-main-container">
      <div className="donation-container">
        {!paymentSuccess && <h2>❤️ Donate to Support</h2>}

        {!showQR && !paymentSuccess && (
          <form className="donation-form animate__animated animate__fadeIn">
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              required
              value={formData.name}
              onChange={handleChange}
            />
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              required
              value={formData.email}
              onChange={handleChange}
            />
            <input
              type="tel"
              name="phone"
              placeholder="Phone Number"
              required
              value={formData.phone}
              onChange={handleChange}
            />
            <textarea
              name="note"
              placeholder="Note (Optional)"
              value={formData.note}
              onChange={handleChange}
            ></textarea>
            <input
              type="number"
              name="amount"
              placeholder="Donation Amount (₹)"
              required
              value={formData.amount}
              onChange={handleChange}
            />

            <button type="button" className="btn-primary" onClick={generateQRCode}>
              Generate QR Code
            </button>
          </form>
        )}

        {showQR && !paymentSuccess && (
          <div className="qr-container animate__animated animate__fadeInUp">
            <QRCodeCanvas value={qrValue} size={200} />
            <p>📲 Scan this QR to pay via UPI</p>
            <button className="btn-success" onClick={handlePaymentSuccess}>
              Payment Done
            </button>
          </div>
        )}

        {paymentSuccess && (
          <div className="success-message animate__animated animate__bounceIn">
            <h3>✅ Payment Successful!</h3>
            <p>Thank you for your generous support! ❤️</p>
            <button className="back-to-form-btn" onClick={() => window.location.reload()}>Thank You</button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Donation;
